import { useCallback, useEffect, useState } from "react";
import { setPreSignupConfig } from "../../utils/SessionManager";
import _isEmpty from "lodash/isEmpty";
// import { usePreSignupApi } from "../../api/usePreSignupApi";
import { useTokenStore } from "../../storage/tokenState";
import { NAVIGATION_ROUTES } from "../../constant";
import { useNavigate } from "react-router-dom";

const useSplash = () => {
  // const { preSignupConfig, error, isLoading, refetch } = usePreSignupApi();
  const [showRetryBottomSheet, setShowRetryBottomSheet] = useState(false);
  const {
    token: userToken,
    splashConfig: { backgroundColor },
  } = useTokenStore();
  const navigate = useNavigate();

  const goToNextScreenPostSplash = useCallback(() => {
    // Wallet is the landing page for now; /home remains the game lobby.
    // if (!_isEmpty(userToken)) {
      navigate(NAVIGATION_ROUTES.WALLET);
    //   return;
    // } else {
    //   navigate(NAVIGATION_ROUTES.SIGNIN);
    //   return;
    // }
  }, [navigate]);

  // useEffect(() => {
  //   if (!_isEmpty(preSignupConfig)) {
  //     setPreSignupConfig(preSignupConfig);
  //   }

  //   // if (error && !isLoading) {
  //   //   setShowRetryBottomSheet(true);
  //   // }
  // }, [preSignupConfig, error, isLoading, refetch]);

  return {
    // refetch,
    videoDetails: {
      //   video: videoToShow,
      backgroundColor,
    },
    goToNextScreenPostSplash,
  };
};

export default useSplash;
